<app-navbar [backgroundBlue]="navbarBackgroundBlue"></app-navbar>
